import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, Mail } from "lucide-react";
import { BUSINESS } from "@/data/site";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-zinc-200 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-6">
          <img
            src="/images/logo-dark.png"
            alt="Amiri Roofing"
            className="h-12 w-auto"
            data-testid="footer-logo"
          />
          <p className="mt-6 text-zinc-500 text-sm max-w-sm leading-relaxed">
            Residential roofing built for Manitoba winters. Winnipeg and
            surrounding areas.
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-accent mb-6">Contact</p>
          <a
            href={BUSINESS.phoneHref}
            data-testid="footer-phone-link"
            className="flex items-center gap-3 text-zinc-900 font-bold text-lg hover:text-accent transition-colors duration-300"
          >
            <Phone size={18} /> {BUSINESS.phone}
          </a>
          <a
            href={`mailto:${BUSINESS.email}`}
            data-testid="footer-email-link"
            className="flex items-center gap-3 text-zinc-500 text-sm mt-4 hover:text-accent transition-colors duration-300"
          >
            <Mail size={16} /> {BUSINESS.email}
          </a>
          <p className="flex items-center gap-3 text-zinc-500 text-sm mt-4">
            <MapPin size={16} /> {BUSINESS.area}
          </p>
          <p className="flex items-center gap-3 text-zinc-500 text-sm mt-2">
            <Clock size={16} /> Mon–Sat, 8am–6pm
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-accent mb-6">Explore</p>
          <div className="flex flex-col gap-3">
            {["Services", "Gallery", "About", "Blog", "Contact"].map((p) => (
              <Link
                key={p}
                to={`/${p.toLowerCase()}`}
                data-testid={`footer-link-${p.toLowerCase()}`}
                className="text-zinc-500 text-sm hover:text-accent transition-colors duration-300"
              >
                {p}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-zinc-200 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-zinc-400 text-xs uppercase tracking-[0.15em]">
          © {new Date().getFullYear()} Amiri Roofing — Winnipeg, MB
        </p>
        <p className="text-zinc-400 text-xs uppercase tracking-[0.15em]">
          Built for -40°C
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
